import { render, staticRenderFns } from "./Manypeople.vue?vue&type=template&id=4e87b970&scoped=true"
import script from "./Manypeople.vue?vue&type=script&lang=js"
export * from "./Manypeople.vue?vue&type=script&lang=js"
import style0 from "./Manypeople.vue?vue&type=style&index=0&id=4e87b970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e87b970",
  null
  
)

export default component.exports